// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WorkspaceMembersListItem__hint-without-menu-ce9f4c {
  margin-inline-end: 48px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/WorkspaceMembersList/WorkspaceMembersListItem/WorkspaceMembersListItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF","sourcesContent":[".hint-without-menu {\n  margin-inline-end: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hint-without-menu": `WorkspaceMembersListItem__hint-without-menu-ce9f4c`,
	"hintWithoutMenu": `WorkspaceMembersListItem__hint-without-menu-ce9f4c`
};
module.exports = ___CSS_LOADER_EXPORT___;
